/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
import { method, render } from '../lib';
import { VimePlayer } from '@vime/core';
import { define } from '../lib';
define('vime-player', VimePlayer);
export default Vue.extend({
    props: {
        attached: {},
        logger: {},
        theme: {},
        paused: {},
        playing: {},
        duration: {},
        mediaTitle: {},
        currentProvider: {},
        currentSrc: {},
        currentPoster: {},
        currentTime: {},
        autoplay: {},
        ready: {},
        playbackReady: {},
        loop: {},
        muted: {},
        buffered: {},
        playbackRate: {},
        playbackRates: {},
        playbackQuality: {},
        playbackQualities: {},
        seeking: {},
        debug: {},
        playbackStarted: {},
        playbackEnded: {},
        buffering: {},
        controls: {},
        isControlsActive: {},
        errors: {},
        textTracks: {},
        currentCaption: {},
        isCaptionsActive: {},
        isSettingsActive: {},
        volume: {},
        isFullscreenActive: {},
        aspectRatio: {},
        viewType: {},
        isAudioView: {},
        isVideoView: {},
        mediaType: {},
        isAudio: {},
        isVideo: {},
        isLive: {},
        isMobile: {},
        isTouch: {},
        isPiPActive: {},
        autopause: {},
        playsinline: {},
        language: {},
        translations: {},
        languages: {},
        i18n: {},
    },
    methods: {
        getProvider: method('getProvider'),
        setProvider: method('setProvider'),
        getAdapter: method('getAdapter'),
        play: method('play'),
        pause: method('pause'),
        canPlay: method('canPlay'),
        canAutoplay: method('canAutoplay'),
        canMutedAutoplay: method('canMutedAutoplay'),
        canSetPlaybackRate: method('canSetPlaybackRate'),
        canSetPlaybackQuality: method('canSetPlaybackQuality'),
        canSetFullscreen: method('canSetFullscreen'),
        enterFullscreen: method('enterFullscreen'),
        exitFullscreen: method('exitFullscreen'),
        canSetPiP: method('canSetPiP'),
        enterPiP: method('enterPiP'),
        exitPiP: method('exitPiP'),
        extendLanguage: method('extendLanguage'),
        callAdapter: method('callAdapter'),
        toggleCaptionsVisibility: method('toggleCaptionsVisibility'),
    },
    render: render('vime-player', ['vThemeChange', 'vPausedChange', 'vPlay', 'vPlayingChange', 'vSeekingChange', 'vSeeked', 'vBufferingChange', 'vDurationChange', 'vCurrentTimeChange', 'vAttachedChange', 'vReady', 'vPlaybackReady', 'vPlaybackStarted', 'vPlaybackEnded', 'vBufferedChange', 'vCurrentCaptionChange', 'vTextTracksChange', 'vErrorsChange', 'vLoadStart', 'vCurrentProviderChange', 'vCurrentSrcChange', 'vCurrentPosterChange', 'vMediaTitleChange', 'vControlsChange', 'vPlaybackRateChange', 'vPlaybackRatesChange', 'vPlaybackQualityChange', 'vPlaybackQualitiesChange', 'vMutedChange', 'vVolumeChange', 'vViewTypeChange', 'vMediaTypeChange', 'vLiveChange', 'vTouchChange', 'vLanguageChange', 'vI18nChange', 'vTranslationsChange', 'vLanguagesChange', 'vFullscreenChange', 'vPiPChange']),
});
//# sourceMappingURL=VimePlayer.js.map